export const LOGO_FY_2025 = "logo_fy_2025"
